export const textToFile = (text, filename) => {
  const fName = filename || "created";

  // var jsonString = JSON.stringify(text);
  var blob = new Blob([text], { type: 'text/plain' });
  var file = new File([blob], `${fName}.txt`, {type: "text/plain"});
  
  return file;
};

export const textToSrtFile = (text, filename) => {
  const fName = filename || "created";

  // var jsonString = JSON.stringify(text);
  var blob = new Blob([text], { type: 'text/plain' });
  var file = new File([blob], `${fName}.srt`, {type: "text/plain"});
  
  return file;
};

export const srtTextToVttFile = (text, filename) => {
  const fName = filename || "created";

  const vttText = srtToVtt(text);
  var blob = new Blob([vttText], { type: 'text/vtt' });
  var file = new File([blob], `${fName}.vtt`, {type: "text/vtt"});
  
  return file;
};


export function srtToVtt(srtContent) {
    // 1. Add the "WEBVTT" header to the beginning of the content.
    let vttContent = "WEBVTT\n\n";

    // 2. Replace the SRT timecode comma decimals (00:00:00,000) with periods (00:00:00.000)
    // as required by the WebVTT format.
    vttContent += srtContent.replace(/(\d+:\d+:\d+),(\d+)/g, '$1.$2');

    // 3. Ensure proper newline characters for WebVTT format (optional, depending on input).
    // The replace above handles the main difference.
    
    return vttContent;
}